module.exports = __webpack_public_path__ + "img/4x3.c2c93580.png";